<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-file-type w-5 h-5"
    aria-hidden="true"
  >
    <path
      d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"
    ></path>
    <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
    <path d="M11 18h2"></path>
    <path d="M12 12v6"></path>
    <path d="M9 13v-.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v.5"></path>
  </svg>
</template>

<script>
export default {
  name: 'TextFileIcon',
}
</script>
